<template>
  <div class="leftMenu">
    <el-menu ref="leftmenu" :default-active="curIndex" :active="curIndex" @select="handleSelect" :default-openeds="['100','200','300']">
      <el-menu-item index="1"><i class="sy-icon-home"></i>首页管理</el-menu-item>
      <el-submenu ref="leftmenu_child" index="100">
        <template slot="title"><i class="el-icon-tickets"></i>订单管理</template>
        <el-menu-item index="order_manage">订单查询</el-menu-item>
      </el-submenu>
      <el-submenu ref="leftmenu_child" index="200">
        <template slot="title"><i class="el-icon-goods"></i>商品管理</template>
        <el-menu-item index="goods_search">商品查询</el-menu-item>
        <el-menu-item index="product">品名管理</el-menu-item>
        <el-menu-item index="goods_type">分类管理</el-menu-item>
      </el-submenu>
      <el-submenu ref="leftmenu_child" index="300">
        <template slot="title"><i class="el-icon-star-off"></i>客户管理</template>
        <el-menu-item index="guest">客户查询</el-menu-item>
      </el-submenu>
      <el-submenu ref="leftmenu_child" index="400">
        <template slot="title"><i class="el-icon-star-on"></i>用户管理</template>
        <el-menu-item index="5">应用管理</el-menu-item>
        <el-menu-item index="6">用户管理</el-menu-item>
        <el-menu-item index="7">仓库管理</el-menu-item>
      </el-submenu>
      <el-submenu ref="leftmenu_child" index="500">
        <template slot="title"><i class="el-icon-setting"></i>系统设置</template>
        <el-menu-item index="sys_setting">应用设置</el-menu-item>
        <el-menu-item index="guest_nogoods">用户商品设置</el-menu-item>
      </el-submenu>
      <el-submenu ref="leftmenu_child" index="600">
        <template slot="title"><i class="el-icon-bell"></i>异常管理</template>
        <el-menu-item index="10">异常订单管理</el-menu-item>  
      </el-submenu>
    </el-menu>
  </div>
</template>

<script type="text/ecmascript-6">
/*import routerinfo from '../router/router.config.json'*/
import { Alert } from "element-ui";
export default {
  data() {
    return {
      operations: [], //window._$base.userInfo.ops,
      curIndex: "1",
      orderShow: false,
      stockinShow: false,
      stockOutShow: false,
      consignShow: false,
      matiShow: false,
      databaseShow: false,
      exceptionShow: false,
      pagerouteInfo: null,
    };
  },
  created() {
    /*var that = this;
      for(var i = 0; i < routerinfo.length; i++){
        if (routerinfo[i].type && routerinfo[i].type == "pages"){
          this.pagerouteInfo = routerinfo[i].children;
        }
      }
      window.eventBus.$on('initIndex', function(index) {
        that.curIndex = index + "";
      })
      //通过userInfo得到用户权限-power，控制菜单显示
      var power = window._$base.userInfo.powers;
      if(power==null||power==""){
        return; //window.location.href = window._$base.rootPath + "/logout.aspx";
      }
      for(var i=0; i < power.length; i++){
        if(power[i]==1||power[i]==2||power[i]==3){
          this.orderShow = true;
          this.exceptionShow = true;
        }
        if(power[i]==1){
         this.stockinShow = true;
        }
        if(power[i]==2){
         this.stockOutShow = true; 
        }
        if(power[i]==3){
          this.consignShow = true;
        }
        if(power[i]==4){
          this.matiShow = true;
        }
        if(power[i]==5){
          this.databaseShow = true;
        }
      }*/
  },
  methods: {
    handleSelect(selectedName) {
      this.$router.push({
        name: selectedName,
      });
    },
    checkMenu(index) {
      var rinfo = this.pagerouteInfo[index];
      if (
        rinfo != null &&
        rinfo.meta != null &&
        rinfo.meta.code != null &&
        rinfo.meta.code != ""
      ) {
        return this.operations.indexOf(rinfo.meta.code) != -1;
      } else {
        return this.operations.indexOf(index) != -1;
      }
      return false;
    },
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace("/", "");
    },
  },
};
</script>
<style lang="scss">
.leftMenu {
  display: block;
  position: fixed;
  bottom: 0;
  top: 60px;
  width: 190px;
  left: 0;
  z-index: 999;
  ul {
    height: 100%;
    border-radius: 0;
    width: 190px;
  }
}
.el-submenu .el-menu-item {
  min-width: auto !important;
}
</style>
